/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { loadModulePromise } from 'src/components/YandexMap/mapLoader';
import { loadReactComponent } from 'src/components/YandexMap/loaders/componentLoaders';
import classnames from 'classnames';
import { useHover } from 'usehooks-ts';
import type {
  Coordinates,
  ShortHotelInfo,
} from 'src/components/YandexMap/types';
import Pip from '@lt/components/icons-react/userflow/Pip';
import type { PopupState } from 'src/routes/SearchPage/store/map/types';
import PointPrice from './components/PointPrice';
import { CENTER_OFFSET_DESKTOP, CENTER_OFFSET_MOBILE } from './constants';

import styles from './point.module.css';

const YMapMarker = loadReactComponent('YMapMarker', loadModulePromise);

export type PointProps = {
  shortHotelInfo: ShortHotelInfo;
  isMobile: boolean;
  setPopupDataHandler: (popupData: PopupState) => void;
  moveToPoint: (
    coordinates: Coordinates,
    zoomDiff: number,
    offset: { x: number; y: number },
  ) => void;
  geometry: {
    type: 'Point';
    coordinates: Coordinates;
  };
  source?: string;
  active?: boolean;
};

const Point = (props: PointProps) => {
  const {
    shortHotelInfo,
    setPopupDataHandler,
    moveToPoint,
    geometry,
    active = false,
    isMobile,
  } = props;

  const hoverRef = React.useRef(null);
  const isHover = useHover(hoverRef);

  const { visited } = shortHotelInfo;

  const openPopup = () => {
    setPopupDataHandler({
      id: shortHotelInfo.id,
      state: shortHotelInfo.state,
      visited: shortHotelInfo.visited,
      coordinates: geometry.coordinates,
    });
  };

  const onClick = () => {
    moveToPoint(geometry.coordinates, 0, {
      x: 0,
      y: isMobile ? CENTER_OFFSET_MOBILE : CENTER_OFFSET_DESKTOP,
    });
    openPopup();
  };

  return (
    <YMapMarker {...props} hideOutsideViewport zIndex={isHover ? 1 : 0}>
      <div className={styles.markerPin} ref={hoverRef}>
        <div
          className={classnames(styles.priceWrapper, {
            [styles.activePriceWrapper]: active,
            [styles.visitedPriceWrapper]: !active && visited,
          })}
          onClick={onClick}
        >
          <PointPrice price={shortHotelInfo.price} />
        </div>
        <Pip
          className={classnames(styles.pip, {
            [styles.activePip]: active,
            [styles.visitedPip]: !active && visited,
          })}
          onClick={onClick}
        />
      </div>
    </YMapMarker>
  );
};

export default Point;
